<!--
	作者：1764635606@qq.com
	时间：2018-06-15
	描述：确认模态框(已全局注册)
	
	props: 
	   value:          控制是否显示
       title：                  标题
       content:        主要内容
       showIcon:       是否显示icon
       icon:           icon类型，默认information-circled
       iconColor:      icon颜色，默认#4eaffa
       action:         点击确定或取消按钮要触发的事件,没有则触发result事件(停用)
	   param:          参数集合
       transfer:       是否将组件放到body下
       buttons:        自定义按钮，会返回一个btnIndex，如果为0则会触发onSure，其他触发onClose
	       
    methods:
        close:         关闭模态框
        sure:          点击确定按钮
    
    emit:
        sure:          点击确定按钮触发该事件
        close:         点击取消按钮或点击遮罩触发该事件
        
       点击确定或取消按钮后会触发sure或close事件
-->

<template>
	<div class="confirm-modal" v-bp-transfer-dom :data-transfer="transfer">
		<BPModal :modal-style="modalStyle" v-if="visible" @close="close" :zIndex="999999">
            <template slot="modal-header">
				{{title}}
			</template>
            <template slot="modal-content">
                <div class="text-content">
                    <div class="text">
                        <Icon v-if="showIcon" class="info-icon" :type="icon" :color="iconColor"></Icon>
                        {{content}}
                    </div>
                </div>
                <div class="flex-row">
                    <template v-for="(item, index) in btns">
                        <div style="width: 50px;" v-if="item === 'space'"></div>
                        <div style="width: 100%;" v-else>
                            <Button :type="item.type" size="large" long :style="{color: item.color}" @click.native="sure(index / 2)">{{item.name}}</Button>
                        </div>
                    </template>
                	<!-- <div class="table-cell">
                		<Button type="primary" size="large" long @click.native="sure">确定</Button>
                	</div>
                	<div class="table-cell" style="width: 20px;"></div>
                	<div class="table-cell">
                		<Button type="default" style="color: #495060;" size="large" long @click.native="close">取消</Button>
                	</div> -->
                </div>
            </template>
        </BPModal>
	</div>
</template>

<script>
// import BPModal from '../BPModal'
import {check} from '@/utils'

export default {
    name: 'BPConfirm',
    // components: { BPModal },
    props: {
        value: {
            default: false
        },
        title: {
            default: '确认'
        },
        content: {
            default: '是否确认该操作?'
        },
        showIcon: {
            type: Boolean,
            default: true
        },
        icon: {
            type: String,
            default: 'information-circled'
        },
        iconColor: {
            type: String,
            default: '#4eaffa'
        },
        width: {
            type: String,
            default: '400px'
        },
        maskClose: {
            type: Boolean,
            default: true
        },
        buttons: {
            type: Array,
            default: () => {
                return ['确定', {name: '取消', type: 'default', color: '#495060'}]
            }
        },
        param: {
            type: Object,
            default: () => {
                return {}
            }
        },
        transfer: {
            type: Boolean,
            default: true
        }
    },
    data () {
        return {
            visible: this.value
        }
    },
    computed: {
        btns () {
            if (!check.isArray(this.buttons)) return []
            let arr = []
            for (let item of this.buttons) {
                let obj = {}
                if (check.isString(item)) {
                    obj = {name: item, color: '', type: 'primary'}
                }
                if (check.isObject(item)) {
                    obj = Object.assign({color: '', type: 'primary'}, item)
                }
                arr.push(obj, 'space')
            }
            arr.splice(arr.length - 1, 1)
            return arr
        },
        modalStyle () {
            return `width: ${this.width}`
        }
    },
    methods: {
        close () {
            if (!this.maskClose) return
            this.visible = false
            this.$emit('input', false)
            // this.$emit('close', this.param)
        },
        sure (i) {
            let param = Object.assign({btnIndex: i}, this.param)
            this.visible = false
            this.$emit('input', false)
            this.$emit('sure', param)
        }
    },
    watch: {
        value (val) {
            this.visible = val
        }
    }
}
</script>

<style lang="less" scoped>
	.info-icon{
	    margin-right: 3px;
	    font-size: 18px;
	    position: relative;
	    top: 2px;
	    color: #4eaffa;
	}
	.text-content{
	    text-align: center;
	    padding: 30px 0 50px;
	    font-size: 13px;
        color: #666666;
        word-wrap: break-word;
    }
    .flex-row{
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
</style>